"use client";

import {
  BMNotificationBannerManager,
  BMNotificationBannerProvider,
} from "@traveloka/district-bloom";
import { NotificationBannerConfigProps } from "@traveloka/district-bloom/js/components/NotificationBannerContainer/types";
import { PropsWithChildren } from "react";

function BMSnackbarProvider({ children }: PropsWithChildren) {
  return (
    <BMNotificationBannerProvider>{children}</BMNotificationBannerProvider>
  );
}

type BMSnackbarConfigProps = {
  type?: NotificationBannerConfigProps["type"];
} & Omit<NotificationBannerConfigProps, "type">;

const BMSnackbarManager = {
  ...BMNotificationBannerManager,
  show: (props: BMSnackbarConfigProps) => {
    BMNotificationBannerManager.show({
      ...props,
      type: props.type || "RED",
      enterAnimationType: props.enterAnimationType || "SLIDE",
      exitAnimationType: props.exitAnimationType || "SLIDE",
      slideEnterAnimationPosition: props.slideEnterAnimationPosition || "RIGHT",
      slideExitAnimationPosition: props.slideExitAnimationPosition || "RIGHT",
      duration: props.duration || 5,
      transitionDuration: props.transitionDuration || 300,
      withCloseButton: props.withCloseButton || true,
    });
  },
};

export { BMSnackbarManager, BMSnackbarProvider };
